import React from 'react';
import {
  ProductExportConfigurationContext,
  ProductExportConfigurationContextProps,
} from '../context/ProductExportConfigurationContext';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';
import { v4 } from 'uuid';
import { ProductExportConfiguration } from '../types/product_export_configuration/productExportConfiguration';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const productExportConfigurationState = {
  items: new Map<string, ProductExportConfiguration>(),
  loading: false,
};

export const productExportConfigurationSlice = createSlice({
  name: 'productExportConfiguration',
  initialState: { key: v4() },
  reducers: {
    reset: state => {
      productExportConfigurationState.items = new Map();
      productExportConfigurationState.loading = true;
      state.key = v4();
    },
    set: (state, action: PayloadAction<ProductExportConfiguration[]>) => {
      productExportConfigurationState.items = new Map();
      action.payload.forEach(p => productExportConfigurationState.items.set(p.id, new ProductExportConfiguration(p)));
      state.key = v4();
    },
    add: (state, action: PayloadAction<ProductExportConfiguration[]>) => {
      action.payload.forEach(p => productExportConfigurationState.items.set(p.id, new ProductExportConfiguration(p)));
      productExportConfigurationState.items = new Map(productExportConfigurationState.items);
      state.key = v4();
    },
    delete: (state, action: PayloadAction<ProductExportConfiguration[]>) => {
      action.payload.forEach(p => productExportConfigurationState.items.delete(p.id));
      productExportConfigurationState.items = new Map(productExportConfigurationState.items);
      state.key = v4();
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      productExportConfigurationState.loading = action.payload;
      state.key = v4();
    },
  },
});

interface ProductExportConfigurationProviderProps {
  children: React.ReactNode;
}

export default function ProductExportConfigurationProvider({ children }: ProductExportConfigurationProviderProps) {
  const dispatch = useAppDispatch();
  const key = useAppSelector(state => state.productExportConfigurations.key);

  const productExportConfigurationContext: ProductExportConfigurationContextProps = {
    productExportConfigurations: productExportConfigurationState.items,
    productExportConfigurationsLoading: productExportConfigurationState.loading,
    setProductExportConfigurations: (items: Map<string, ProductExportConfiguration>) => {
      dispatch(productExportConfigurationSlice.actions.set([...items.values()]));
    },
  };

  return (
    <ProductExportConfigurationContext.Provider value={productExportConfigurationContext}>
      {children}
    </ProductExportConfigurationContext.Provider>
  );
}
